import axios from "axios";

export const loginUtenteApi = (user) => {
    return axios.post(process.env.REACT_APP_API_ENDPOINT + "/api/sost/utente/login", user);
};

export const loginUserSsoApi = (idUser, pwd) => {
    return axios.get(process.env.REACT_APP_ENDPOINT_VALIDATE_TOKEN + '?jwt=' + pwd + '&id=' + idUser, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};

export const getRefreshTokenSsoApi = (token) => {
    return axios.post(process.env.REACT_APP_API_ENDPOINT + "/api/sost/utente/login-sso",
        {
            auth: token,
        })
};

export const callRefreshToken = (idUser, refreshToken) => {
    return axios.post(process.env.REACT_APP_API_ENDPOINT + "/api/sost/utente/refresh-token",
        {
            id: idUser,
            refresh_token: refreshToken
        },
        {
            headers: {
                "Content-Type": "application/json"
            }
        });
};